export const LANGUAGE_UPDATE = 'LANGUAGE_UPDATE'


// WEBPACK FOOTER //
// ./src/redux/actionTypes.js